module.exports = __webpack_public_path__ + "static/media/test-drive.6ba1b46d.svg";